/**
 * Performs left-to-right function composition, where the input data is the first
 * argument, and the 1-5 fallowing arguments are all unary functions. The
 * curried form of `pipe` must be manually created with an arrow function.
 *
 * Code based off of https://github.com/selfrefactor/rambda/blob/master/src/compose.js
 */
export function pipe<A, B>(value: A, f1: (a: A) => B): B;
export function pipe<A, B, C>(value: A, f1: (a: A) => B, f2: (b: B) => C): C;
export function pipe<A, B, C, D>(value: A, f1: (a: A) => B, f2: (b: B) => C, f3: (c: C) => D): D;
export function pipe<A, B, C, D, E>(value: A, f1: (a: A) => B, f2: (b: B) => C, f3: (c: C) => D, f4: (d: D) => E): E;
export function pipe<A, B, C, D, E, F>(
  value: A,
  f1: (a: A) => B,
  f2: (b: B) => C,
  f3: (c: C) => D,
  f4: (d: D) => E,
  f5: (e: E) => F
): F;

export function pipe(...args: any[]) {
  const [data, ...fns] = args;
  if (fns.length > 0) {
    const fn = fns.shift();
    let result = fn(data);
    while (fns.length > 0) {
      result = fns.shift()(result);
    }

    return result;
  }

  return data;
}
